export default "{\n    \"placeholderText\": \"Select date range\"\n}\n"